import React, { useEffect } from "react";
import { Modal, Button, Collapse, Tag } from "antd";

const { Panel } = Collapse;

const ModalViewResultISMS = ({ open, onCancel, listResultExam }) => {
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleContextMenu);

    const handleKeyDown = (e) => {
      if (
        (e.ctrlKey && ["c", "C", "s", "S", "p", "P"].includes(e.key)) ||
        e.key === "PrintScreen"
      ) {
        e.preventDefault();
        alert("Hành động này bị chặn");
      }
    };
    document.addEventListener("keydown", handleKeyDown);

    document.body.style.userSelect = "none";

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      document.body.style.userSelect = "auto";
    };
  }, []);

  const splitAnswers = (ansString) => {
    if (!ansString) return [];
    return ansString.toString().split("+");
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title="Kết quả bài thi của đợt thi"
      style={{ minWidth: "500px" }}
      width={800}
      footer={null}
      bodyStyle={{ paddingTop: 10 }}
      maskClosable={false}
    >
      {listResultExam && listResultExam.length > 0 ? (
        <div style={{ maxHeight: "600px", overflowY: "auto", paddingRight: 8 }}>
          <Collapse accordion>
            {listResultExam.map((item, index) => {
              const userSelected = splitAnswers(item.dap_an_chon);
              const correctAnswers = splitAnswers(item.dap_an_dung);
              const answers = item.dap_an.split("‡");

              return (
                <Panel
                  header={`Câu ${index + 1}: ${item.cau_hoi}`}
                  key={item.id}
                  style={{ marginBottom: 8 }}
                >
                  <div>
                    {answers.map((ans, i) => {
                      const ansNumber = (i + 1).toString();
                      const isCorrect = correctAnswers.includes(ansNumber);
                      const isSelected = userSelected.includes(ansNumber);

                      return (
                        <div
                          key={i}
                          style={{
                            marginBottom: 4,
                            padding: "4px 8px",
                            borderRadius: 4,
                            backgroundColor: isCorrect
                              ? "#d4edda"
                              : isSelected
                              ? "#f8d7da"
                              : "transparent",
                          }}
                        >
                          <strong>{ansNumber}. </strong>
                          {ans}{" "}
                          {isCorrect && (
                            <Tag color="green" style={{ marginLeft: 8 }}>
                              Đáp án đúng
                            </Tag>
                          )}
                          {isSelected && !isCorrect && (
                            <Tag color="red" style={{ marginLeft: 8 }}>
                              Bạn chọn
                            </Tag>
                          )}
                          {isSelected && isCorrect && (
                            <Tag color="green" style={{ marginLeft: 8 }}>
                              Bạn chọn
                            </Tag>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </Panel>
              );
            })}
          </Collapse>
        </div>
      ) : (
        <div style={{ textAlign: "center", padding: "50px 0" }}>
          Bạn đã thi đạt và không sai câu nào
          <div style={{ marginTop: 16 }}>
            <Button onClick={onCancel}>Thoát</Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default ModalViewResultISMS;
